import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant.js';

export const FJSliceTextToSpeech = createSlice({
    name: 'TextToSpeech',
    initialState: {
        tabIndex: 0,
        languageValue: 'en',
        languageList: [],
        voiceInfo: {},
        styleInfo: {},
        favoriteList: [],
        loadingFavoriteIdList: [],
        loadingFavoriteListStatus: FJConstant.DEFAULT,

        currentVoiceFromType: FJConstant.MICROSOFT,
        currentAvatarUrl: '',
        currentVoiceUrl: '',
        currentName: '',
        currentStyle: '',
        currentStyleList: [],
        currentSpeed: 1,
        currentPitch: 1,
        currentSpeechList: [],
        recentUseVoiceList: [],
        currentCountryInfo: {},
        isShowLibraryModal: false,
        speechSelectId: null,

        projectList: [],

        freeNumCreationTextToSpeech: 0,
        freeNumCreationOfVoiceClone: 0,

        isShowTTVProjectModal: false,
        ttvProjectInfo: {},

        currentBottomCurrentTime: 0,
        currentBottomTotalTime: 0,
        isPlayingInBottom: false,
        currentBottomSpeechId: null,

        currentTime: 0,

        downloadStatus: FJConstant.DEFAULT,
    },
    reducers: {
        setSliceDownloadStatus: (state, action) => {
            state.downloadStatus = action.payload;
        },
        setSliceTabIndex: (state, action) => {
            state.tabIndex = action.payload;
        },
        setSliceLanguageList: (state, action) => {
            state.languageList = action.payload;
        },
        setSliceVoiceInfo: (state, action) => {
            state.voiceInfo = action.payload;
        },
        setSliceStyleInfo: (state, action) => {
            state.styleInfo = action.payload;
        },
        setSliceFavoriteList: (state, action) => {
            state.favoriteList = action.payload;
        },
        setSliceCurrentVoiceFromType: (state, action) => {
            state.currentVoiceFromType = action.payload;
        },
        setSliceCurrentAvatarUrl: (state, action) => {
            state.currentAvatarUrl = action.payload;
        },
        setSliceCurrentVoiceUrl: (state, action) => {
            state.currentVoiceUrl = action.payload;
        },
        setSliceCurrentName: (state, action) => {
            state.currentName = action.payload;
        },
        setSliceCurrentStyle: (state, action) => {
            state.currentStyle = action.payload;
        },
        setSliceCurrentSpeed: (state, action) => {
            state.currentSpeed = action.payload;
        },
        setSliceCurrentPitch: (state, action) => {
            state.currentPitch = action.payload;
        },
        setSliceCurrentSpeechList: (state, action) => {
            state.currentSpeechList = action.payload;
        },
        setSliceRecentUseVoiceList: (state, action) => {
            state.recentUseVoiceList = action.payload;
        },
        setSliceCurrentCountryInfo: (state, action) => {
            state.currentCountryInfo = action.payload;
        },
        setSliceCurrentStyleList: (state, action) => {
            state.currentStyleList = action.payload;
        },
        setSliceIsShowLibraryModal: (state, action) => {
            state.isShowLibraryModal = action.payload;
        },
        setSliceSpeechSelectId: (state, action) => {
            state.speechSelectId = action.payload;
        },
        setSliceProjectList: (state, action) => {
            state.projectList = action.payload;
        },
        setSliceSpeechLanguageValue: (state, action) => {
            state.languageValue = action.payload;
        },
        setSliceFreeNumCreationTextToSpeech: (state, action) => {
            state.freeNumCreationTextToSpeech = action.payload;
        },
        setSliceFreeNumCreationOfVoiceClone: (state, action) => {
            state.freeNumCreationOfVoiceClone = action.payload;
        },
        setSliceTTVProjectInfo: (state, action) => {
            state.ttvProjectInfo = action.payload;
        },
        setSliceIsShowTTVProjectModal: (state, action) => {
            state.isShowTTVProjectModal = action.payload;
        },
        setSliceLoadingFavoriteIdList: (state, action) => {
            state.loadingFavoriteIdList = action.payload;
        },
        setSliceCurrentBottomCurrentTime: (state, action) => {
            state.currentBottomCurrentTime = action.payload;
        },
        setSliceCurrentBottomTotalTime: (state, action) => {
            state.currentBottomTotalTime = action.payload;
        },
        setSliceIsPlayingInBottom: (state, action) => {
            state.isPlayingInBottom = action.payload;
        },
        setSliceCurrentBottomSpeechId: (state, action) => {
            state.currentBottomSpeechId = action.payload;
        },
        updateCurrentTime: (state, action) => {
            state.currentTime = action.payload;
        },
        setSliceLoadingFavoriteListStatus: (state, action) => {
            state.loadingFavoriteListStatus = action.payload;
        },
    },
});

export const {
    setSliceTabIndex,
    setSliceLanguageList,
    setSliceVoiceInfo,
    setSliceStyleInfo,
    setSliceFavoriteList,
    setSliceCurrentVoiceFromType,
    setSliceCurrentAvatarUrl,
    setSliceCurrentVoiceUrl,
    setSliceCurrentName,
    setSliceCurrentStyle,
    setSliceCurrentSpeed,
    setSliceCurrentPitch,
    setSliceCurrentSpeechList,
    setSliceRecentUseVoiceList,
    setSliceCurrentStyleList,
    setSliceCurrentCountryInfo,
    setSliceIsShowLibraryModal,
    setSliceSpeechSelectId,
    setSliceProjectList,
    setSliceSpeechLanguageValue,
    setSliceFreeNumCreationTextToSpeech,
    setSliceFreeNumCreationOfVoiceClone,
    setSliceTTVProjectInfo,
    setSliceIsShowTTVProjectModal,
    setSliceLoadingFavoriteIdList,
    setSliceCurrentBottomCurrentTime,
    setSliceCurrentBottomTotalTime,
    setSliceIsPlayingInBottom,
    setSliceCurrentBottomSpeechId,
    updateCurrentTime,
    setSliceLoadingFavoriteListStatus,
    setSliceDownloadStatus,
} = FJSliceTextToSpeech.actions;

export default FJSliceTextToSpeech.reducer;
